import { render, staticRenderFns } from "./ApproveWindow.vue?vue&type=template&id=60f256a2&scoped=true"
import script from "./ApproveWindow.vue?vue&type=script&lang=ts&setup=true"
export * from "./ApproveWindow.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ApproveWindow.vue?vue&type=style&index=0&id=60f256a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f256a2",
  null
  
)

export default component.exports